import React, { useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import AppWrapper from '../../../components/AppWrapper';
import Button from '../../../components/Button';
import { LinkComponent } from '../../../components/Link';
import { TextH3, TextP } from '../../../components/Text';
import { useUniversity } from '../../../hooks';
import * as Styled from '../../../styles/EditDeleteStyles';
import { fonts } from '../../../styles/theme';

const UniversityDelete = () => {
  const location: any = useLocation();
  const params = useParams();

  const {
    nameSingle,
    name,
    baseUrl,
    universities,
    selectecUniversities,
    setSelectecUniversities,
    handleDelete,
    getUniversityById,
    getBreadcrumbs,
  } = useUniversity();

  useEffect(() => {
    if (location.state?.ids) {
      setSelectecUniversities(location.state.ids);
      getUniversityById(location.state.ids);
    }
  }, [location]);

  useEffect(() => {
    if (params.id) {
      setSelectecUniversities([parseInt(params.id, 10)]);
      getUniversityById([parseInt(params.id, 10)]);
    }
  }, [params]);

  return (
    <AppWrapper breadcrumbs={getBreadcrumbs()}>
      <Styled.TextWrapper>
        <TextH3 font={fonts.font1.H20}>Are you sure?</TextH3>
      </Styled.TextWrapper>
      {universities.length === 1 ? (
        <TextP font={fonts.font1.H14}>
          Are you sure you want to delete the {nameSingle} “{universities[0].name}”? All of the following related items will be deleted:
        </TextP>
      ) : (
        <TextP font={fonts.font1.H14}>
          Are you sure you want to delete the selected {name}? All of the following objects and their related items will be deleted:
        </TextP>
      )}
      <div>
        <Styled.TextWrapper>
          <TextP font={fonts.font1.H16B}>Summary</TextP>
          <Styled.ListStyled>
            <li>
              {name}: {universities.length}
            </li>
          </Styled.ListStyled>
        </Styled.TextWrapper>
      </div>
      <div>
        <TextP font={fonts.font1.H16B}>Objects</TextP>
        {universities && (
          <Styled.ListStyled>
            {universities?.map((authority: { name?: string, id?: number }) => (
              <li key={authority.id}>
                {nameSingle}: {' '}
                <LinkComponent url={`/${baseUrl}}/${authority.id}`}>
                  {authority.name}
                </LinkComponent>
              </li>
            ))}
          </Styled.ListStyled>
        )}
        <Styled.FlexBoxStyled>
          <Button
            onClick={() => handleDelete(selectecUniversities)}
            theme="warning"
          >
            <TextP font={fonts.font1.H12}>Yes, I&apos;m sure</TextP>
          </Button>
          <Styled.ButtonWrapper>
            <LinkComponent
              url={universities.length === 1 ? `/${baseUrl}/${universities[0].id}/change` : `/${baseUrl}`}
              theme="buttonSecondary"
            >
              <div>
                <TextP font={fonts.font1.H12}>
                  No, take me back
                </TextP>
              </div>
            </LinkComponent>
          </Styled.ButtonWrapper>
        </Styled.FlexBoxStyled>
      </div>
    </AppWrapper>
  );
};

export default UniversityDelete;
